import { createFileRoute, Navigate } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { useModels } from '@/api/models'
import { usePools } from '@/api/pools'
import { useProduct } from '@/api/products'
import { useWorkspace } from '@/api/workspace'
import { LoadingSkeleton } from '@/components/loading-skeleton'
import { VariantForm } from '@/components/variants/variant-form'

// Variant create (UI-SCREENS P-09, #102). Owner only; the API refuses Staff too. Not on an
// archived Product (the API answers 422).
export const Route = createFileRoute('/w/$slug/products/$productId/variants/new')({
  component: NewVariant,
  staticData: { breadcrumb: 'variants.form.newTitle' },
})

function NewVariant() {
  const { t } = useTranslation()
  const { slug, productId } = Route.useParams()
  const workspace = useWorkspace(slug)
  const product = useProduct(slug, Number(productId))
  const models = useModels(slug, Number(productId))
  const pools = usePools(slug, { archived: true })

  if (workspace.data && workspace.data.role !== 'owner') {
    return <Navigate to="/w/$slug/products/$productId" params={{ slug, productId }} replace />
  }

  const queries = [product, models, pools]
  return (
    <section className="flex flex-col gap-4">
      <h1 className="font-heading text-xl font-semibold">{t('variants.form.newTitle')}</h1>
      {queries.some((query) => query.isPending) ? (
        <LoadingSkeleton variant="form" rows={4} />
      ) : !product.data || !models.data || !pools.data ? (
        <p role="alert" className="text-sm text-destructive">
          {t('errors.generic')}
        </p>
      ) : (
        <>
          <p className="text-sm text-muted-foreground">
            {product.data.code} · {product.data.name}
          </p>
          <VariantForm slug={slug} product={product.data} models={models.data} pools={pools.data} />
        </>
      )}
    </section>
  )
}
